import { Alignment, HorizontalPadding, TopPadding } from '@easeltv/client-sdk';
import styled from 'styled-components';

import { interpretFooterSpacing } from '../../../utilities';

export const StyledFooterList = styled.ul`
    padding: 0;
    margin: 0;
    line-height: 1.3;
    max-width: 40rem;
    display: inline-block;
    width: 100%;
    font-size: 0.9em;

    li {
        display: inline-block;
        margin: 0 0.938rem;

        :first-child {
            margin-left: 0;
        }

        :last-child {
            margin-right: 0;
        }
    }

    :empty {
        display: none;
    }
`;

export const StyledFooterLinksBlock = styled.div<{
    alignment: Alignment;
    topPadding: TopPadding;
    horizontalPadding: HorizontalPadding;
}>(
    ({ alignment, topPadding, horizontalPadding }) => `
        text-align: ${alignment};

        ${StyledFooterList}{
            text-align: ${alignment};
            padding-top: ${interpretFooterSpacing(topPadding)};
            padding-left: ${interpretFooterSpacing(horizontalPadding)};
            padding-right: ${interpretFooterSpacing(horizontalPadding)};
        }
    `,
);
